// SwitchButton.vue
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CreateElement } from 'vue'

@Component
export default class SwitchButton extends Vue {
  @Prop({ default: false })
  defaultSelected: boolean
  @Prop({ required: true })
    private selected: Function
  @Prop({ required: true })
    private unSelected: Function
  @Prop({ required: true })
    private selectedIcon: any
  @Prop({ required: true })
    private unSelectedIcon: any

  private isSelected: boolean = false

  @Watch('defaultSelected', { immediate: true })
  onDefaultSelectedChange (newVal: boolean) {
    this.isSelected = newVal
  }

  toggle () {
    this.isSelected = !this.isSelected
    this.isSelected ? this.selected() : this.unSelected()
  }

  render (h: CreateElement) {
    return (
            <button class={'switch-button'} onClick={this.toggle}>
                {this.isSelected
                    ? this.selectedIcon ? this.selectedIcon : <span>✓</span>
                    : this.unSelectedIcon ? this.unSelectedIcon : <span>✗</span>}
            </button>
    )
  }
}
